
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";

/**
 * Hook personnalisé pour gérer l'état de navigation
 * - Stocke l'historique de navigation
 * - Permet de revenir en arrière facilement
 * - Suit la page actuelle
 */
export const useNavigationState = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [navigationHistory, setNavigationHistory] = useLocalStorage<string[]>("navigation_history", []);
  const [lastVisitedPage, setLastVisitedPage] = useLocalStorage<string>("last_visited_page", "/");
  
  // Mettre à jour l'historique de navigation
  useEffect(() => {
    // Ne pas enregistrer les mêmes pages consécutives
    if (navigationHistory.length === 0 || navigationHistory[navigationHistory.length - 1] !== location.pathname) {
      // Limiter la taille de l'historique à 10 entrées
      const newHistory = [...navigationHistory, location.pathname].slice(-10);
      setNavigationHistory(newHistory);
      setLastVisitedPage(location.pathname);
    }
  }, [location.pathname]);

  // Fonction pour revenir à la page précédente avec fallback
  const goBack = () => {
    if (navigationHistory.length > 1) {
      // Retirer la page actuelle
      const newHistory = [...navigationHistory];
      newHistory.pop();
      // Aller à la page précédente
      const previousPage = newHistory[newHistory.length - 1];
      navigate(previousPage);
      setNavigationHistory(newHistory);
    } else {
      // Fallback à la page d'accueil si pas d'historique
      navigate('/');
    }
  };

  return { 
    currentPath: location.pathname,
    navigationHistory,
    lastVisitedPage,
    goBack
  };
};
